import React, { forwardRef, useCallback } from 'react';
import { SharedValue } from 'react-native-reanimated';

import { LobbyRoom as LobbyRoomType } from '../../../store/types';
import { WheelCarousel, WheelCarouselHandle } from '../common/WheelCarousel';
import { LobbyRoom } from '../Lobby/LobbyRoom';

export type LobbyRoomCarouselHandle = WheelCarouselHandle;

type Props = {
	rooms: LobbyRoomType[];
	activeIndex: number;
	onActiveIndexChange: (index: number) => void;
	width: number;
	height: number;
	cardWidth: number;
	cardHeight: number;
	progress?: SharedValue<number>;
};

const LobbyRoomCarouselInner = (
	{
		rooms,
		activeIndex,
		onActiveIndexChange,
		width,
		height,
		cardWidth,
		cardHeight,
		progress,
	}: Props,
	ref: React.Ref<LobbyRoomCarouselHandle>,
) => {
	const renderItem = useCallback(
		({ item, index }: { item: LobbyRoomType; index: number }) => (
			<LobbyRoom
				index={index}
				totalCount={rooms.length}
				room={item}
				cardWidth={cardWidth}
				cardHeight={cardHeight}
				progress={progress}
				framed
				isFeatured={false}
				visualScale={1}
				shouldRenderSpine={false}
				playing={false}
			/>
		),
		[cardHeight, cardWidth, progress, rooms.length],
	);

	return (
		<WheelCarousel
			ref={ref}
			data={rooms}
			renderItem={renderItem}
			activeIndex={activeIndex}
			onActiveIndexChange={onActiveIndexChange}
			width={width}
			height={height}
			cardWidth={cardWidth}
			cardHeight={cardHeight}
			progress={progress}
		/>
	);
};

export const LobbyRoomCarousel = forwardRef(LobbyRoomCarouselInner);

export default LobbyRoomCarousel;
